import axios from '@/api/config';

const goodsInfo = {
  getGoodsInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsInfo/` + data, {});
  },
  getGoodsInfo(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsInfo`, {
      params: data
    });
  },
  getGoodsInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsInfoList`, {
      params: data
    });
  },
  getGoodsInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsInfoTree`, {
      params: data
    });
  },
  getGoodsInfoStats(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsInfoStats`, {
      params: data
    });
  },
  getGoodsTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsTypeList`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/pageList`, data);
  },
  goodsBatchOn(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/goodsBatchOn`, data);
  },
  goodsBatchOff(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/goodsBatchOff`, data);
  },
  addGoodsInfo(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/addGoodsInfo`, data);
  },
  updateGoodsInfo(data) {
    return axios.put(`${process.env.BASE_URL}/goodsInfo/updateGoodsInfo`, data);
  },
  deleteGoodsInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/goodsInfo/deleteGoodsInfo`, {
      data: data
    });
  },
  seriesGoodsBatchOff(data) {
    return axios.post(`${process.env.BASE_URL}/seriesGoods/seriesGoodsBatchOff`, data);
  },
  seriesGoodsBatchOn(data) {
    return axios.post(`${process.env.BASE_URL}/seriesGoods/seriesGoodsBatchOn`, data);
  },
  deleteSeriesGoods(data) {
    return axios.delete(`${process.env.BASE_URL}/seriesGoods/deleteSeriesGoods`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/exportExcel`, {
      params: data
    });
  },
  getStudentBuyGoodsList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getStudentBuyGoodsList`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/importData`, data);
  },
  goodsMarketPageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/goodsMarketPageList`, data);
  },
  batchAddGoodsInfo(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/batchAddGoodsInfo`, data);
  },
  addSeriesGoods(data) {
    return axios.post(`${process.env.BASE_URL}/seriesGoods/addSeriesGoods`, data);
  },
  seriesGoodsPageList(data) {
    return axios.post(`${process.env.BASE_URL}/seriesGoods/pageList`, data);
  },
  pageListHasAgentPrice(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/pageListHasAgentPrice`, data);
  },
  pageListInformation(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/informationPageList`,
      data
    );
  },
  copyGoodsInfo(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/copyGoodsInfo`, {
      params: data
    });
  },
  updateSeriesGoods(data) {
    return axios.put(`${process.env.BASE_URL}/seriesGoods/updateSeriesGoods`, data);
  },
  getSeriesGoods(data) {
    return axios.get(`${process.env.BASE_URL}/seriesGoods/getSeriesGoods`, {
      params: data
    });
  },
  // 专栏 获取录播接口 
  getGoodsInfoByType(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/getGoodsInfoByType`, data)
  },
  getGoodsCommentList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsComment/getGoodsCommentList`, {
      params: data
    });
  },
  updateGoodsComment(data) {
    return axios.put(`${process.env.BASE_URL}/goodsComment/updateGoodsComment`, data);
  },
}

export default goodsInfo;



// WEBPACK FOOTER //
// ./src/api/goodsInfo.js